<template>
  <b-modal
    ref="resellers_modal"
    id="resellers-modal"
    @show="onShow"
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
    centered
  >
    <div style="height: 525px; max-width: 100%; overflow-y: auto">
      <b-card class="m-2" no-body>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize">{{ $t("table.entries") }} </label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                  @input="onTypeSearch"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refListTable"
          class="position-relative"
          :items="itemsData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="$t('no_record_found')"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #head(firstName)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(lastName)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(contactEmail)="data">
            <span> {{ $t(data.label) }}</span>
          </template>

          <template #head(accountOwnerId)="">
            <b-form-checkbox
              v-if="totalList"
              id="select-all"
              value="1"
              unchecked-value="0"
              v-model="selectAll"
              :disabled="isBusy"
            >
            </b-form-checkbox>
          </template>

          <template #cell(accountOwnerId)="data">
            <b-form-checkbox
              :disabled="data.item.exist"
              :id="`reseller-${data.item.accountOwnerId}`"
              :value="data.item.accountOwnerId"
              unchecked-value="0"
              v-model="resellersModel"
              @change="checkItem(data.item)"
            >
            </b-form-checkbox>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalList"
                :per-page="perPage"
                prev-class="prev-item"
                next-class="next-item"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <template #modal-footer>
      <b-button
        variant="info"
        size="sm"
        class="text-capitalize"
        :disabled="buttonUpdate"
        @click="updateResellers"
      >
        {{ $t("actions.update") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        class="text-capitalize"
        :disabled="buttonUpdate"
        @click="$bvModal.hide('resellers-modal')"
      >
        {{ $t("actions.cancel") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BTable, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, watch, computed } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import Pagination from "@/components/Pagination.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import { debounce } from "lodash";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    vSelect,
    Pagination,
    ToastificationLoadingContent,
  },
  props: {
    masterAccountFilter: {
      type: Number,
      default: null,
    },
  },

  setup(props, { emit, parent }) {
    const isBusy = ref(false);
    const refListTable = ref(null);
    const perPage = ref(10);
    const totalList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const buttonUpdate = ref(false);
    const resellers = ref([]);
    const resellersModel = ref([]);
    const resellersTemp = ref([]);
    const resellersResponse = ref([]);
    const selectAll = ref(null);
    const loadingToast = ref(null);
    const toast = useToast();
    const resellers_modal = ref(null);

    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalList.value,
      };
    });

    const itemsData = computed(() => {
      return resellersResponse.value.slice(
        (currentPage.value - 1) * perPage.value,
        currentPage.value * perPage.value
      );
    });

    watch(selectAll, () => {
      if (selectAll.value == 1) {
        resellers.value = resellersResponse.value.filter(reseller => !reseller.exist);
        resellersModel.value = resellersResponse.value.map(reseller => reseller.accountOwnerId);

      } else {
        resellers.value = [];
        resellersModel.value = resellersResponse.value.map(reseller => reseller.exist ? reseller.accountOwnerId : null )
      }
    });

    watch(resellers, () => {
      if(resellers.value.length === 0){
        selectAll.value = 0;
      }
    });
    
    
    const onShow = () => {
      getResellers();
    };

    const clear = () => {
      selectAll.value = 0;
      resellers.value = [];
    };

    const checkItem = (reseller) => {
      const res  = resellersTemp.value.find(r => r.accountOwnerId == reseller.accountOwnerId);
      if(resellers.value.find(item => item.accountOwnerId === reseller.accountOwnerId)){
        let r =  resellers.value.filter(item => item.accountOwnerId !== reseller.accountOwnerId);
        resellers.value = r;
      }
      else{
        resellers.value.push(res)
      }
    }

    const getResellers = () => {
      clear();
      isBusy.value = true;
      totalList.value = 0;

      store
        .dispatch("cm_reseller/getResellers", {
          id_master_account: props.masterAccountFilter,
        })
        .then((response) => {
          if (response.success) {
            resellersResponse.value = response.data.resellers;
            resellersTemp.value = resellersResponse.value;
            resellersModel.value = resellersResponse.value.map(reseller => reseller.exist ? reseller.accountOwnerId : null )
            totalList.value = response.data.resellers.length;
            isBusy.value = false;
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const onTypeSearch = debounce(function (event) {
      clear();
      if (event === "") {
        resellersResponse.value = resellersTemp.value;
        resellersModel.value = resellersTemp.value.map(reseller => reseller.exist ? reseller.accountOwnerId : null )
        totalList.value = resellersResponse.value.length;
        return;
      }

      const search = event.toLowerCase();
      resellersResponse.value = resellersTemp.value.filter(
        (item) =>
          item.firstName.toLowerCase().includes(search) ||
          item.contactEmail.toLowerCase().includes(search)
      );

      currentPage.value = 1;
      totalList.value = resellersResponse.value.length;
    }, 800);

    const updateResellers = () => {
      if (resellers.value.length === 0) {
        return toast({
          component: ToastificationContent,
          props: {
            title: parent.$i18n.t("reseller.validation"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      emit("loading-toast-event", { data: true });
      buttonUpdate.value = true;

      store
        .dispatch("cm_reseller/updateResellers", {
          id_master_account: props.masterAccountFilter,
          resellers: resellers.value,
        })
        .then((response) => {
          if (response.success) {
            clear();
            buttonUpdate.value = false;
            resellers_modal.value.hide();
            emit("loading-toast-event", { data: false });
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: "Error al actualizar resellers",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error al actualizar resellers",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    return {
      isBusy,
      perPage,
      totalList,
      currentPage,
      perPageOptions,
      refListTable,
      tableColumns: [
        { label: "", key: "accountOwnerId", sortable: false },
        { label: "reseller.name", key: "firstName", sortable: false },
        { label: "reseller.email", key: "contactEmail", sortable: false },
      ],
      resellersModel,
      resellers,
      resellersTemp,
      resellersResponse,
      buttonUpdate,
      selectAll,
      itemsData,
      dataMeta,
      loadingToast,
      resellers_modal,

      clear,
      onShow,
      onTypeSearch,
      getResellers,
      updateResellers,
      checkItem,
    };
  },
};
</script>